<style lang="scss">
    .filter-bar {
        position: relative;
        .filter-header-wrapper {
            display: flex;
            flex-wrap: wrap;
        }
        .filter-button {
            cursor: pointer;
        }
        .filter-icon {
            font-size: 20px;
        }
        .filter-title {
            position: relative;
            margin-left: 5px;
            top: -2px;
        }
        .filter-label-wrapper {
            display: flex;
            flex-wrap: wrap;
            margin-left: 15px;
            margin-right: 50px;
            .filter-label {
                font-size: 13px;
                border: 1px solid #e6e6e6;
                border-radius: 5px;
                padding: 2px 21px 2px 10px;
                position: relative;
                margin-right: 5px;
                margin-bottom: 5px;
            }
            .filter-label-icon {
                position: absolute;
                top: 1px;
                right: 0px;
                font-size: 11px;
                padding: 5px;
                cursor: pointer;
            }
        }
    }
    .filter-options-wrapper {
        transition: max-height 0.3s;
        left: 0;
        overflow: hidden;
        box-shadow: 0 0px 20px rgba(0,0,0,.16);
        border-radius: 5px;
        position: absolute;
        z-index: 10;
        background: #fff;
        width: 100%;
        top: 35px;
        &.open {
            max-height: 200px !important;
            z-index: 12 !important;
        }
        .inner-container {
            display: flex;
            padding: 20px 0px;
        }
        .filter-option {
            flex: 1;
            padding: 0 20px;
            border-right: 1px solid #e6e6e6;
            font-weight: normal;
            &:last-child {
                border: none;
            }
            select {
                font-size: 14px;
            }
        }
        .divider {
            width: 97%;
            margin: auto;
            border-bottom: 2px solid #e6e6e6;
        }
        .buttons-wrapper {
            padding: 20px 20px 20px 0;
            .btn {
                height: 40px;
                font-size: 14px;
                box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
            }
            .reset-button {
                padding: 12px 10px;
                width: 83px;
            }
            .search-button {
                padding: 12px 30px;
                background-color: #00d38a;
                color: #fff;
            }
        }
    }

    @media screen and (max-width: 767px) {
        .filter-options-wrapper {
            .filter-option {
                padding: 0 12px;
                select {
                    font-size: 13px;
                    padding: 8px;
                }
            }
        }
    }

    @media screen and (max-width: 550px) {
        .filter-options-wrapper {
            &.open {
                max-height: 665px !important;
            }
            .inner-container {
                display: block;
            }
            .filter-option {
                padding: 10px 20px;
            }
        }
    }
</style>
<template>
    <div class="filter-bar" @click.stop>
        <div>
            <div class="filter-header-wrapper">
                <span class="filter-button" @click="toggleFilterBar" :style="$mainSecondaryTextStyle">
                    <font-awesome-icon class="filter-icon" icon="sort-amount-down"></font-awesome-icon> <span class="filter-title">Filter</span>

                    <font-awesome-icon v-if="openFilterBar" class="filter-button-caret" :icon="['far', 'angle-up']"></font-awesome-icon>
                    <font-awesome-icon v-else class="filter-button-caret" :icon="['far', 'angle-down']"></font-awesome-icon>
                </span>
                <transition name="fade">
                    <div class="filter-label-wrapper" :style="$mainSecondaryTextStyle">
                        <div v-if="tags" class="filter-label" :style="$borderColorStyle">{{tags}} <span class="filter-label-icon" @click="clearFilter('tags')"><font-awesome-icon icon="times"></font-awesome-icon></span></div>
                        <div v-if="genreFilterSet" class="filter-label" :style="$borderColorStyle" @click="clearFilter('genre')">{{genreString}} <span class="filter-label-icon"><font-awesome-icon :icon="['fal', 'times']"></font-awesome-icon></span></div>
                        <div v-if="moodsFilterSet" class="filter-label" :style="$borderColorStyle">{{filters.moods}} <span class="filter-label-icon" @click="clearFilter('moods')"><font-awesome-icon :icon="['fal', 'times']"></font-awesome-icon></span></div>
                        <div v-if="temposFilterSet" class="filter-label" :style="$borderColorStyle">{{filters.tempo}} <span class="filter-label-icon" @click="clearFilter('tempo')"><font-awesome-icon :icon="['fal', 'times']"></font-awesome-icon></span></div>
                        <div v-if="musicKeyFilterSet" class="filter-label" :style="$borderColorStyle">{{musicKeyName}} <span class="filter-label-icon" @click="clearFilter('keys')"><font-awesome-icon :icon="['fal', 'times']"></font-awesome-icon></span></div>
                        <div v-if="addedFilterSet" class="filter-label" :style="$borderColorStyle">{{addedString}} <span class="filter-label-icon" @click="clearFilter('added')"><font-awesome-icon :icon="['fal', 'times']"></font-awesome-icon></span></div>
                        <div v-if="orderFilterSet" class="filter-label" :style="$borderColorStyle">{{filters.order}} <span class="filter-label-icon" @click="clearFilter('order')"><font-awesome-icon :icon="['fal', 'times']"></font-awesome-icon></span></div>
                    </div>
                </transition>
                <div v-if="tags"><button class="btn btn-sm btn-default" @click="updateFilter('tags', null)"> CLEAR</button></div>
            </div>

            <div class="filter-options-wrapper" style="max-height: 0px; overflow: hidden;" :class="{'open' : openFilterBar}" :style="$musicContainerShadow">
                <div :style="$mainBodyStyle">
                    <div class="inner-container" :style="$mainSecondaryTextStyle">
                        <div class="filter-option" :style="$borderColorStyle">
                            <label for="genre"><font-awesome-icon icon="headphones"></font-awesome-icon> Genre</label>
                            <select class="form-control" v-model="genre" id="genre">
                                <option value="0">- All Genres -</option>
                                <option v-for="genre in genresArray" :value="genre.id">{{genre.name}}</option>
                            </select>
                        </div>

                        <div class="filter-option" :style="$borderColorStyle">
                            <label for="mood"><font-awesome-icon :icon="['far','smile']"></font-awesome-icon> Moods</label>
                            <select class="moods-select form-control" v-model="moods" id="mood">
                                <option value="">- All Moods -</option>
                                <option v-for="mood in moodsArray" :value="mood.name">{{mood.name}}</option>
                            </select>
                        </div>

                        <div class="filter-option" :style="$borderColorStyle">
                            <label for="music-key"><font-awesome-icon icon="music-alt"></font-awesome-icon> Key</label>
                            <select class="moods-select form-control" v-model="musicKey" id="music-key">
                                <option value="">- All Keys -</option>
                                <option v-for="key in musicKeysArray" :value="key.id ">{{key.value}}</option>
                            </select>
                        </div>

                        <div class="filter-option" :style="$borderColorStyle">
                            <label for="tempo"><font-awesome-icon icon="waveform-path"></font-awesome-icon> BPM</label>
                            <select class="moods-select form-control" v-model="tempo" id="tempo">
                                <option value="">- All -</option>
                                <option v-for="tempo in temposArray" :value="tempo['.key']">{{tempo['.value']}}</option>
                            </select>
                        </div>

                        <div class="filter-option" :style="$borderColorStyle">
                            <label for="added"><font-awesome-icon :icon="['far', 'calendar-alt']"></font-awesome-icon> Added</label>
                            <select class="form-control" v-model="added" id="added">
                                <option value="1">Today</option>
                                <option value="7">Last 7 Days</option>
                                <option value="30">Last 30 Days</option>
                                <option value="192">Last 6 months</option>
                                <option value="365">Last 12 months</option>
                                <option value="0">- All Time -</option>
                            </select>
                        </div>

                        <div class="filter-option" :style="$borderColorStyle">
                            <label for="order"><font-awesome-icon :icon="['far', 'long-arrow-down']"></font-awesome-icon> Sort By</label>
                            <select class="form-control" v-model="order" id="order">
                                <option value="">- Default -</option>
                                <option value="newest">Newest</option>
                                <option value="oldest">Oldest</option>
                                <option value="plays">Most Plays</option>
                            </select>
                        </div>

                    </div>

                    <div :style="$borderColorStyle" class="divider"></div>

                    <div class="clearfix">
                        <div class="buttons-wrapper pull-right">
                            <div class="reset-button btn" :style="$mainButtonStyle" @click="reset()">Reset</div>
                            <div class="search-button btn" @click="filter()">Filter</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Configure from './../../mixins/configure'
    import BeatRepository from './../../mixins/beat-repository'

    export default {
        mounted () {
            if (this.genresArray.length == 0 || this.moodsArray.length == 0) {
                Promise.all([
                    this.$http.get(`${ab.apiUrl}/users/${ab.user.id}/beats/moods`),
                    this.$http.get(`${ab.apiUrl}/users/${ab.user.id}/beats/genres`)])
                    .then((response) => {
                        this.$store.commit('setMoodsAndGenres', {
                            moods: response[0].data.items,
                            genres: response[1].data.items
                        })

                        this.setFiltersFromUrlQuery()
                    })
            }
            if(this.musicKeysArray.length == 0) {
                this.setFiltersFromUrlQuery()
                Promise.all([
                    this.$http.get(`${ab.apiUrl}/beats/music-keys`)])
                    .then((response) => {
                        let resultArray = Object.entries(response[0].data).map(([index, value]) => {
                            return { id: index, value: value };
                        });
                        resultArray = resultArray.filter(obj => obj.id !== "0");

                        this.$store.commit('setMusicKeys', {
                            musicKeys: resultArray,
                        })
                        this.setFiltersFromUrlQuery()
                    })
            }
        },
        data() {
            return {
                openFilterBar: false,
                genre: this.$store.state.filters.genre,
                moods: this.$store.state.filters.moods,
                added: this.$store.state.filters.added,
                order: this.$store.state.filters.order,
                tempo: this.$store.state.filters.tempo,
                musicKey: this.$store.state.filters.keys,
            }
        },
        computed: {
            filters() {
                return this.$store.state.filters
            },
            defaultFilters() {
                return this.$store.state.defaultFilters
            },
            genresArray() {
                return this.$store.state.genres
            },
            moodsArray() {
                return this.$store.state.moods
            },
            musicKeysArray() {
                return this.$store.state.musicKeys
            },
            temposArray () {
                return this.$store.state.tempos
            },
            tags() {
                return this.filters.tags
            },
            genreFilterSet() {
                return this.isFilterSet('genre')
            },
            moodsFilterSet() {
                return this.isFilterSet('moods')
            },
            musicKeyFilterSet() {
                return this.isFilterSet('keys')
            },
            temposFilterSet() {
                return this.isFilterSet('tempo')
            },
            addedFilterSet() {
                return this.isFilterSet('added')
            },
            orderFilterSet() {
                return this.isFilterSet('order')
            },
            genreString() {
                let genre = this.getGenreFromIdOrAlias(this.filters.genre)

                if (genre) return genre.name
            },
            addedString() {
                switch(this.filters.added) {
                    case '0':
                        return 'All time'
                    case '1':
                        return 'Today'
                    case '7':
                    case '30':
                        return `Last ${this.filters.added} Days`
                    case '192':
                        return 'Last 6 months'
                    case '365':
                        return 'Last 12 months'
                }
            },
            musicKeyName() {
                const key = this.filters.keys;
                if(!this.musicKeysArray.length) return "";
                const musicKeyName = this.musicKeysArray.find(obj => obj.id === key);
                return musicKeyName ? musicKeyName.value : "";
            },
        },
        mixins: [Configure, BeatRepository],
        methods: {
            updateFilter(filter, value) {
                let filters = {}
                filters[filter] = value

                this.$store.commit('setBeatFilters', {filters: filters})
            },
            toggleFilterBar() {
                this.openFilterBar = !this.openFilterBar
            },
            filter() {
                let filters = {
                    genre: this.genre,
                    moods: this.moods,
                    added: this.added,
                    order: this.order,
                    tempo: this.tempo,
                    keys: this.musicKey
                }
                this.$store.commit('setBeatFilters', {filters: filters})

                this.toggleFilterBar()
            },
            clearFilter(filter) {
                this.updateFilter(filter, this.defaultFilters[filter])
                this[filter] = this.defaultFilters[filter]
            },
            reset() {
                this.$store.commit('setBeatFilters', {filters: this.$store.state.defaultFilters})

                this.genre = this.filters.genre
                this.moods = this.filters.moods
                this.added = this.filters.added
                this.order = this.filters.order
                this.tempo = this.filters.tempo
                this.musicKey = this.filters.keys
            },
            isFilterSet(filter) {
                if (this.filters[filter] != this.defaultFilters[filter]) {
                    return true
                }
                return false
            },
        },
        watch: {
            '$store.state.closeFilterBar'(val) {
                if (val) {
                    this.openFilterBar = false
                    this.$store.commit("closeFilterBar", {close: false})
                }
            }
        }
    }
</script>
